import { Box, Drawer, IconButton } from '@chakra-ui/react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';
import { FiMenu } from 'react-icons/fi';

import useLocalStorageWatch from '@/hooks/use-local-storage-watch';

import SidebarItems from './SidebarItems';

const Sidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useLocalStorageWatch<boolean>('sidebarOpen', true);

  return (
    <>
      <Drawer.Root placement="start" size="full">
        <Drawer.Backdrop />
        <Drawer.Trigger asChild>
          <IconButton
            display={{ base: 'flex', md: 'none' }}
            aria-label="Open Menu"
            position="absolute"
            fontSize="20px"
            zIndex={99}
            m={4}
          >
            <FiMenu />
          </IconButton>
        </Drawer.Trigger>
        <Drawer.Content offset="4" rounded="md" style={{ height: 'calc(100vh - var(--r3-spacing-4);)' }}>
          <Drawer.CloseTrigger />
          <Drawer.Body py={8}>
            <SidebarItems />
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Root>

      {/* Desktop */}
      <Box
        w={sidebarOpen ? '240px' : '72px'}
        p={4}
        h="100vh"
        boxShadow="lg"
        display={{ base: 'none', md: 'block' }}
        pos={'relative'}
        transition="all 0.3s ease-in-out"
        zIndex={3}
      >
        <IconButton
          pos={'absolute'}
          variant={'outline'}
          bg={{ base: 'white', _dark: 'gray.800' }}
          aria-label="Toggle Sidebar"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          right={'-3'}
          top={'6'}
          size={'2xs'}
        >
          {sidebarOpen ? <FaAngleLeft /> : <FaAngleRight />}
        </IconButton>
        <SidebarItems collapsed={!sidebarOpen} />
      </Box>
    </>
  );
};

export default Sidebar;
